import * as React from 'react';
import { SelectInput, SelectInputProps, required as requiredValidate } from 'react-admin';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import { Theme } from 'src/Theme';
import { ReactComponent as ChevronDown } from 'src/assets/chevron-down.svg';

type Option = {
    value: string;
    name: string;
};

interface ShsSelectInputProps extends SelectInputProps {
    label?: string;
    onChangeValue?: (option: Option) => void;
    disabled?: boolean;
    isTruncatedOptions?: boolean;
    'label-sx'?: any;
}

export const selectInputSx = {
    '.MuiOutlinedInput-root': {
        '&:hover fieldset': {
            borderColor: Theme.palette.primary.main
        },
        '&:focus fieldset': {
            border: `3px solid #75CACB`
        }
    },
    '&.MuiFormControl-root': {
        margin: 0
    },
    '& .MuiInputBase-root': {
        background: '#ffffff'
    },
    '& legend': {
        display: 'none'
    },
    '& .MuiInputBase-input': {
        padding: '11px 16px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
        top: 0
    },
    '& .MuiSelect-nativeInput': {
        height: '100%'
    },
    '& .MuiSelect-icon': {
        height: '16px',
        cursor: 'pointer'
    },
    '& .MuiSelect-icon MuiSelect-iconOpen': {
        height: '16px',
        cursor: 'pointer'
    }
};
const renderOption = (record: any, isTruncatedOptions: boolean) => {
    return isTruncatedOptions ? (
        <Tooltip title={record.name} arrow>
            <span style={{ display: 'block', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {record.name}
            </span>
        </Tooltip>
    ) : (
        <span style={{ textWrap: 'wrap' }}>{record.name}</span>
    );
};

const StyledLabel = styled('label')<{ disabled?: boolean }>(({ disabled }) => ({
    whiteSpace: 'nowrap',
    color: disabled ? '#8899A8' : 'inherit'
}));

const ShsSelectInput: React.FC<ShsSelectInputProps> = ({
    label,
    required,
    onChangeValue,
    sx = {},
    disabled = false,
    isTruncatedOptions = false,
    'label-sx': labelSX,
    ...props
}) => {
    const isRequired = () => (required ? '*' : '');
    const validateFn = [...(required ? [requiredValidate()] : [])];
    const handleChange = (e: any) => {
        const option = e.target as unknown as Option;
        onChangeValue && onChangeValue(option);
    };

    return (
        <div className={`text_field__container top ${disabled ? 'disabled' : ''}`}>
            <StyledLabel className="text_field__label" disabled={disabled} sx={labelSX}>
                {label || ''}
                {isRequired()}
            </StyledLabel>
            <SelectInput
                validate={validateFn}
                label={false}
                sx={{
                    ...selectInputSx,
                    ...(sx || {}),
                    '& .MuiInputBase-root': {
                        background: disabled ? '#f0f0f0' : '#ffffff',
                        color: disabled ? '#8899A8' : 'inherit'
                    }
                }}
                onChange={handleChange}
                disabled={disabled}
                SelectProps={{
                    IconComponent: ChevronDown,
                    MenuProps: {
                        PaperProps: {
                            sx: {
                                maxWidth: ''
                            }
                        }
                    }
                }}
                optionText={(r) => renderOption(r, isTruncatedOptions)}
                {...props}
            />
        </div>
    );
};

export default ShsSelectInput;
